import { Flex, IconButton } from '@chakra-ui/react'
import { TFunction, useTranslation } from 'next-i18next'
import LinkButton from '_app/components/Buttons/LinkButton'
import {
  BusIcon,
  GiftIcon,
  ArrowCurwLeft,
  ClockIcon,
  ThirtyDaysIcon,
} from '_app/components/Icons'
import { useRouter } from '_app/hooks/useRouter'
import ConfigurationHelper from '../../../helpers/ConfigurationHelper/ConfigurationHelper'

const OrderInfo = () => {
  const router = useRouter()
  const { locale } = router
  const { t } = useTranslation('product')
  const getLink = (array) => {
    return locale === 'pl' ?
        array[0]
        : locale === 'de' ?
            array[1]
            : locale === 'fr' ?
                array[2]
                : array[3]
  }
  const defaultOptions = (t: TFunction) => {
    const options: any = [
      {
        icon: <BusIcon />,
        label: t('DELIVERY_TIME'),
        link: getLink(['/informacje/czas-i-koszty-dostawy', '/information/lieferung', '/information/livraison', '/information/shipping']),
        disableLinkForLocales: ['de'],
      },
      {
        icon: <ClockIcon />,
        label: t('SERVICE_TIME'),
        link: getLink(['/informacje/czas-i-koszty-dostawy', '/information/lieferung', '/information/livraison', '/information/shipping']),
        disableLinkForLocales: ['de'],
        addStar: true,
      },
      {
        icon: <ArrowCurwLeft />,
        label: t('TIME_TO_RETURN'),
        link: getLink(['/informacje/zwroty-i-reklamacje', '/information/widerrufsrecht-fuer-verbraucher', '/information/retours-et-reclamations', '/information/terms-and-conditions']),
      },
    ]
    if (ConfigurationHelper.getConfiguration('enable_klarna', router) === '1') {
      options.push({
        icon: (
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 722.17 304.53">
              <g>
                <g>
                  <path style={{ fill: '#FFB1D2' }} d="M109.17,0.31c49.27-0.6,98.56-0.13,147.84-0.28C371.32,0.08,485.64-0.06,599.96,0.1
              c21.92,0.43,44.23,0.1,65.6,5.68c17.98,4.61,33.11,17.12,43.39,32.3c9.17,13.67,11.84,30.42,13.22,46.5
              c1.86,24.79,1.34,49.66,1.45,74.5c-0.08,20.67,0.15,41.39-1.55,62.02c-1.32,14.64-3.76,29.69-11.33,42.55
              c-7.36,12-17.73,22.25-30.03,29.14c-16.13,8.57-34.78,9.98-52.68,10.99c-26.66,1.12-53.35,0.64-80.03,0.75
              c-139.34-0.03-278.69,0.07-418.04-0.05c-16.31-0.09-32.66-0.19-48.92-1.73c-13.49-1.36-27.27-3.81-39.22-10.56
              c-11.07-6.48-20.51-15.67-27.58-26.36c-7.91-12.11-10.79-26.66-12.31-40.82C0.02,206.07,0.14,187,0,167.99
              C0.12,142.01-0.43,116,1.06,90.05c1.12-16.13,2.96-32.81,10.77-47.26c7.89-13.84,19.88-25.54,34.2-32.61
              C65.76,1.28,87.92,1.07,109.17,0.31z M90.5,86.78c0,43.5,0,87,0,130.5c9.83,0,19.67,0,29.5,0c0.01-21.57-0.01-43.13,0.01-64.7
              c16.28,21.57,32.55,43.14,48.84,64.7c12,0,24-0.01,35.99,0c-15.6-20.63-31.29-41.22-46.91-61.84
              c8.24-6.15,15.66-13.51,21.34-22.11c9.2-13.65,13.85-30.13,13.77-46.55c-9.47,0-18.94,0-28.41,0
              c-0.03,12.37-4.25,24.49-11.18,34.66c-8.39,12.81-20.86,22.06-33.44,30.41c-0.02-21.69,0-43.38-0.01-65.07
              C110.17,86.78,100.33,86.78,90.5,86.78z M213.44,217.28c9.27,0,18.54,0,27.81,0c0-43.5,0-87,0-130.5c-9.27,0-18.54,0-27.81,0
              C213.43,130.28,213.43,173.78,213.44,217.28z M284.98,126.02c-11.23,2.76-20.97,10.54-26.47,20.67
              c-7.19,13.11-8.11,29.28-3.39,43.38c4.09,12.25,13.67,22.75,25.96,27.07c11.3,3.98,24.7,3.69,34.94-2.98
              c5.77-3.57,9.53-9.33,12.91-15.03c-1.34,6-3.6,11.87-3.25,18.15c9.07,0,18.13,0,27.19,0c0-30.06,0-60.12,0-90.18
              c-9.06,0-18.12-0.01-27.18,0c-0.28,6.29,1.76,12.27,3.42,18.24c-3.1-4.61-5.81-9.66-10.32-13.1
              C309.52,124.51,296.38,123.15,284.98,126.02z M462.07,134.98c-2.79,3.1-4.33,7.06-6.96,10.28c1.76-5.92,3.68-11.9,3.45-18.15
              c-9.06-0.03-18.13-0.01-27.19-0.01c0.02,30.06-0.01,60.12,0.01,90.18c9.29,0,18.58,0,27.87,0c0-15.77,0-31.53,0-47.29
              c-0.08-5.75,1.54-11.89,5.9-15.88c4.38-4.21,10.91-5.25,16.75-4.42c3.83,0.5,7.66,2.3,9.97,5.49c3.12,4.24,3.78,9.72,3.76,14.84
              c-0.01,15.75-0.01,31.5,0,47.26c9.29,0,18.58,0,27.87,0c-0.02-19.43,0.04-38.86-0.03-58.28c-0.11-9.47-4.21-18.89-11.43-25.09
              c-8.94-7.85-21.6-10.52-33.18-8.75C472.26,126.12,466.23,129.81,462.07,134.98z M552.1,132.14
              c-10.79,7.38-17.33,19.89-18.87,32.71c-1.96,14.97,2.04,31.22,12.77,42.2c9.61,10.08,24.46,14.47,38.08,12.01
              c7.6-1.32,14.73-5.32,19.65-11.29c2.25-2.62,3.66-5.83,5.9-8.46c-1.76,5.85-3.67,11.77-3.36,17.97c9.03,0,18.07,0,27.1,0
              c0-30.06,0.01-60.12,0-90.18c-9.04,0-18.08-0.01-27.11,0c-0.35,6.25,1.78,12.16,3.29,18.11c-2.82-4.06-5.06-8.6-8.9-11.83
              C587.49,121.42,566.21,122.34,552.1,132.14z M366.57,127.1c-0.01,30.06-0.01,60.12,0,90.18c9.28,0,18.57,0,27.86,0
              c0.11-14.75,0.11-29.51,0.21-44.26c0.07-6.28,2.23-13.13,7.72-16.73c5.3-3.6,12.13-3.08,18.09-1.73
              c-0.03-9.21-0.01-18.41-0.01-27.61c-6.94-1.32-14.68-0.46-20.18,4.31c-4.67,3.53-6.91,9.04-9.78,13.94
              c1.45-5.96,3.61-11.85,3.27-18.09C384.69,127.08,375.63,127.1,366.57,127.1z" />
                </g>
                <path style={{ fill: '#FFB1D2' }} d="M297.41,149.64c11.18-2.93,23.47,4.45,26.55,15.49c2.83,8.91-0.12,19.42-7.5,25.25
            c-6.45,5.33-16.01,6.46-23.5,2.74c-7.27-3.42-12.25-10.98-12.81-18.96C278.96,163.22,286.59,152.05,297.41,149.64z" />
                <path style={{ fill: '#FFB1D2' }} d="M577.44,149.78c8.1-2.2,17.28,0.68,22.61,7.17c6.55,7.63,7.34,19.51,1.84,27.93
            c-4.13,6.7-12.01,10.88-19.89,10.39c-7.43-0.27-14.45-4.67-18.15-11.08c-4.07-6.85-4.33-15.78-0.63-22.84
            C566.05,155.72,571.33,151.37,577.44,149.78z" />
              </g>
              <g>
                <path style={{ fill: '#0B051D' }} d="M90.5,86.78c9.83,0,19.67,0,29.5,0c0.01,21.69-0.01,43.38,0.01,65.07c12.58-8.35,25.05-17.6,33.44-30.41
            c6.93-10.17,11.15-22.29,11.18-34.66c9.47,0,18.94,0,28.41,0c0.08,16.42-4.57,32.9-13.77,46.55c-5.68,8.6-13.1,15.96-21.34,22.11
            c15.62,20.62,31.31,41.21,46.91,61.84c-11.99-0.01-23.99,0-35.99,0c-16.29-21.56-32.56-43.13-48.84-64.7
            c-0.02,21.57,0,43.13-0.01,64.7c-9.83,0-19.67,0-29.5,0C90.5,173.78,90.5,130.28,90.5,86.78z" />
                <path style={{ fill: '#0B051D' }} d="M213.44,217.28c-0.01-43.5-0.01-87,0-130.5c9.27,0,18.54,0,27.81,0c0,43.5,0,87,0,130.5
            C231.98,217.28,222.71,217.28,213.44,217.28z" />
                <g>
                  <path style={{ fill: '#0B051D' }} d="M284.98,126.02c11.4-2.87,24.54-1.51,33.81,6.22c4.51,3.44,7.22,8.49,10.32,13.1
              c-1.66-5.97-3.7-11.95-3.42-18.24c9.06-0.01,18.12,0,27.18,0c0,30.06,0,60.12,0,90.18c-9.06,0-18.12,0-27.19,0
              c-0.35-6.28,1.91-12.15,3.25-18.15c-3.38,5.7-7.14,11.46-12.91,15.03c-10.24,6.67-23.64,6.96-34.94,2.98
              c-12.29-4.32-21.87-14.82-25.96-27.07c-4.72-14.1-3.8-30.27,3.39-43.38C264.01,136.56,273.75,128.78,284.98,126.02z
               M297.41,149.64c-10.82,2.41-18.45,13.58-17.26,24.52c0.56,7.98,5.54,15.54,12.81,18.96c7.49,3.72,17.05,2.59,23.5-2.74
              c7.38-5.83,10.33-16.34,7.5-25.25C320.88,154.09,308.59,146.71,297.41,149.64z" />
                </g>
                <path style={{ fill: '#0B051D' }} d="M462.07,134.98c4.16-5.17,10.19-8.86,16.79-9.82c11.58-1.77,24.24,0.9,33.18,8.75
            c7.22,6.2,11.32,15.62,11.43,25.09c0.07,19.42,0.01,38.85,0.03,58.28c-9.29,0-18.58,0-27.87,0c-0.01-15.76-0.01-31.51,0-47.26
            c0.02-5.12-0.64-10.6-3.76-14.84c-2.31-3.19-6.14-4.99-9.97-5.49c-5.84-0.83-12.37,0.21-16.75,4.42
            c-4.36,3.99-5.98,10.13-5.9,15.88c0,15.76,0,31.52,0,47.29c-9.29,0-18.58,0-27.87,0c-0.02-30.06,0.01-60.12-0.01-90.18
            c9.06,0,18.13-0.02,27.19,0.01c0.23,6.25-1.69,12.23-3.45,18.15C457.74,142.04,459.28,138.08,462.07,134.98z" />
                <g>
                  <path style={{ fill: '#0B051D' }} d="M552.1,132.14c14.11-9.8,35.39-10.72,48.55,1.24c3.84,3.23,6.08,7.77,8.9,11.83
              c-1.51-5.95-3.64-11.86-3.29-18.11c9.03-0.01,18.07,0,27.11,0c0.01,30.06,0,60.12,0,90.18c-9.03,0-18.07,0-27.1,0
              c-0.31-6.2,1.6-12.12,3.36-17.97c-2.24,2.63-3.65,5.84-5.9,8.46c-4.92,5.97-12.05,9.97-19.65,11.29
              c-13.62,2.46-28.47-1.93-38.08-12.01c-10.73-10.98-14.73-27.23-12.77-42.2C534.77,152.03,541.31,139.52,552.1,132.14z
               M577.44,149.78c-6.11,1.59-11.39,5.94-14.22,11.57c-3.7,7.06-3.44,15.99,0.63,22.84c3.7,6.41,10.72,10.81,18.15,11.08
              c7.88,0.49,15.76-3.69,19.89-10.39c5.5-8.42,4.71-20.3-1.84-27.93C594.72,150.46,585.54,147.58,577.44,149.78z" />
                </g>
                <path style={{ fill: '#0B051D' }} d="M366.57,127.1c9.06,0,18.12-0.02,27.18,0.01c0.34,6.24-1.82,12.13-3.27,18.09c2.87-4.9,5.11-10.41,9.78-13.94
            c5.5-4.77,13.24-5.63,20.18-4.31c0,9.2-0.02,18.4,0.01,27.61c-5.96-1.35-12.79-1.87-18.09,1.73c-5.49,3.6-7.65,10.45-7.72,16.73
            c-0.1,14.75-0.1,29.51-0.21,44.26c-9.29,0-18.58,0-27.86,0C366.56,187.22,366.56,157.16,366.57,127.1z" />
              </g>
            </svg>
        ),
        label: t('KLARNA_PAYMENT'),
        link: getLink(['/informacje/formy-platnosci-klarna', '', '', '']),
        type: 'image',
        disableLinkForLocales: ['de', 'fr', 'en'],
      })
    }
    options.push({
      icon: <ThirtyDaysIcon />,
      label: t('FORMS_OF_PAYMENT'),
      link: getLink(['/informacje/formy-platnosci', '/information/zahlungsmethoden', '/information/modes-de-paiement', '/information/payment-methods']),
    })
    options.push({
      icon: <GiftIcon />,
      label: t('GIFT_PACKAGE'),
      link: getLink(['/informacje/jak-pakujemy', '/information/verpackung', '/information/comment-preparons-nous-vos-colis', '/information/see-how-we-pack']),
    })
    return options
  }

  const getHref = (link: string, disableLinkForLocales?: string[]) => {
    if (disableLinkForLocales && disableLinkForLocales.includes(locale)) {
      return undefined
    }
    return link
  }

  return (
      <Flex flexDirection="column" as="ul">
        {defaultOptions(t).map(option => (
            <Flex as="li" key={option.label} alignItems="center" mb={4}>
              <IconButton aria-label="previous" variant="icon" icon={option.icon} sx={{ marginRight: '10px' }} />
              {
                option.type === 'image' ? (
                    <LinkButton
                        image={true}
                        ml={3}
                        textStyle="bodyLight"
                        fontSize="sm"
                        href={getHref(option.link, option.disableLinkForLocales) ? `/${locale}${getHref(option.link, option.disableLinkForLocales)}.html` : '#'}
                    >
                      {option.label} {option.addStar && ' *'}
                    </LinkButton>
                ) : (
                    <LinkButton
                        ml={3}
                        textStyle="bodyLight"
                        fontSize="sm"
                        href={getHref(option.link, option.disableLinkForLocales) ? `/${locale}${getHref(option.link, option.disableLinkForLocales)}.html` : '#'}
                    >
                      {option.label} {option.addStar && ' *'}
                    </LinkButton>
                )
              }
            </Flex>
        ))}
      </Flex>
  )
}

export default OrderInfo
